import { INSERT_ADMINISTRATIVE_PANEL_DATA, GET_QUEUES } from './mutation-types'

export default {
  [INSERT_ADMINISTRATIVE_PANEL_DATA]: (state, administrativePanelData) => {
    state.administrativePanelData = administrativePanelData
  },
  [GET_QUEUES]: (state, queues) => {
    state.filas = queues
  },
}
